// @flow

import { GLOBAL_APP_COUNT } from '@zapier/constants';

export { APP_INTENTION } from 'app/developer-v3/utils/constants';

export const issueStatuses = {
  OPEN: 1,
  CLOSED: 2,
  CLOSE_REQUESTED: 3,
};

export const issueTypes = {
  BUG: 1,
  FEATURE_REQUEST: 2,
};

export const ALL_VERSIONS_TEXT = 'All';

export const AUDIT_LOGS_LIMIT = 50;

export const BUILDER_URL = '/developer/builder';

export const DOCUMENTATION_URL = '/developer/documentation';

export const DEVELOPER_GUIDE_URL = '/developer/start';

export type PartnerTiersType = 'BRONZE' | 'SILVER' | 'GOLD' | 'PLATINUM';
export const PARTNER_TIERS = [
  {
    key: 'BRONZE',
    label: 'Bronze',
    next: 'SILVER',
    prev: null,
    perks: [
      `Buzz-building Launch Campaign`,
      `Access to Integration Health Data`,
      `Dedicated Page in Zapier's App Directory`,
      `"Best Of" Roundup Posts on the Zapier Blog`,
      `Exposure on Zapier's ${GLOBAL_APP_COUNT}+ Partner Sites`,
    ],
  },
  {
    key: 'SILVER',
    label: 'Silver',
    next: 'GOLD',
    prev: 'BRONZE',
    perks: [
      `Get Leads from Zapier's App Directory`,
      `Product Overview on Zapier's App Directory`,
      `Integration Announcements on the Zapier Product Blog`,
    ],
  },
  {
    key: 'GOLD',
    label: 'Gold',
    next: 'PLATINUM',
    prev: 'SILVER',
    perks: [
      `Case Study on the Zapier Blog`,
      `Participation in Promotional Launches`,
    ],
  },
  {
    key: 'PLATINUM',
    label: 'Platinum',
    next: null,
    prev: 'GOLD',
    perks: [
      `Exclusive Dedicated Email to Your Zapier Users`,
      `Quarterly Business Reviews with the Zapier Team`,
      `Hands-on Training`,
    ],
  },
];
type TiersMapType = {
  [PartnerTiersType]: {
    key: PartnerTiersType,
    label: string,
    next: ?PartnerTiersType,
    prev: ?PartnerTiersType,
    perks: string[],
  },
};
export const TIERS_MAP: TiersMapType = PARTNER_TIERS.reduce(
  (map, tier) => ({ ...map, [tier.key]: tier }),
  {}
);
export type PartnerUsageStatisticsType = {
  statistics: {
    quarterly: {
      values: number[],
      labels: string[],
    },
    monthly: {
      values: number[],
      labels: string[],
    },
  },
};
export type PartnerUsageHealthScoreType =
  | 'NA'
  | 'POOR'
  | 'HEALTHY'
  | 'EXCEPTIONAL';
export const HEALTH_SCORE_MAP = {
  NA: 'Not Enough Data',
  POOR: 'Poor',
  HEALTHY: 'Healthy',
  EXCEPTIONAL: 'Exceptional',
};
const HEALTH_MESSAGES = {
  untested: `You'll need at least 20 users before we can calculate your Health Score.`,
  poorMove: 'Get to healthy or above to move to next level.',
  poorMaintain: 'Get to healthy or above to maintain your current level.',
  congratsMove:
    'Congrats! Keep your health score at healthy or above to move to the next level.',
  congratsMaintain:
    'Congrats! Your health score qualifies you to stay in Platinum.',
};
export const HEALTH_TIER_MESSAGES = {
  BRONZE: {
    NA: HEALTH_MESSAGES.untested,
    POOR: HEALTH_MESSAGES.poorMove,
    HEALTHY: HEALTH_MESSAGES.congratsMove,
    EXCEPTIONAL: HEALTH_MESSAGES.congratsMove,
  },
  SILVER: {
    NA: HEALTH_MESSAGES.untested,
    POOR: HEALTH_MESSAGES.poorMaintain,
    HEALTHY: HEALTH_MESSAGES.congratsMove,
    EXCEPTIONAL: HEALTH_MESSAGES.congratsMove,
  },
  GOLD: {
    NA: HEALTH_MESSAGES.untested,
    POOR: HEALTH_MESSAGES.poorMaintain,
    HEALTHY: HEALTH_MESSAGES.congratsMove,
    EXCEPTIONAL: HEALTH_MESSAGES.congratsMove,
  },
  PLATINUM: {
    NA: HEALTH_MESSAGES.untested,
    POOR: HEALTH_MESSAGES.poorMaintain,
    HEALTHY: HEALTH_MESSAGES.congratsMaintain,
    EXCEPTIONAL: HEALTH_MESSAGES.congratsMaintain,
  },
};

export const STATUS_ACCEPTED = 'accepted';
export const ROLE_COLLABORATOR = 'collaborator';
export const ROLE_SUBSCRIBER = 'subscriber';

export const APP_STATUSES = {
  PRIVATE: 0,
  PENDING: 1,
  INVITE: 2,
  GLOBAL: 3,
};

export const APP_USAGE_TEXT = 'Usage stats are no longer available.';
